import request from '../../../../setup/axios/request'

export const getListSubmit = (data: any) => {
  let obj: any = {}
  if (data && data.filter) {
    obj.Page = data.pageNum ? data.pageNum : '1'
    obj.PageSize = '20'
    obj.isPagingEnabled = false
    obj.Filters = data.filter
  } else {
    obj.Page = data.pageNum ? data.pageNum : '1'
    obj.PageSize = '20'
    obj.isPagingEnabled = false
    obj.Filters = []
    if (data.sellingContractId) {
      let dataFilter = {
        FieldName: 'sellingContractId',
        Comparision: '==',
        FieldValue: data.sellingContractId,
      }
      obj.Filters.push(dataFilter)
    }
    if (data.refId) {
      let dataFilter = {
        FieldName: 'refId',
        Comparision: '==',
        FieldValue: data.refId,
      }
      obj.Filters.push(dataFilter)
    }
  }

  return request({
    url: 'api/v1/SubmitForApproval/get-list-submit',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const getSubmitById = (id: string) => {
  return request({
    url: 'api/v1/SubmitForApproval/get-Submit-byid?id=' + id,
    method: 'get',
  })
}

export const getContractPackageByCode = (packageCode: string, sellingContractId: number) => {
  return request({
    url:
      'api/v1/SubmitForApproval/get-contractPackage-by-code?code=' +
      packageCode +
      '&sellingContractId=' +
      sellingContractId,
    method: 'get',
  })
}

export const saveSubmitContract = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/add-submit',
    method: 'post',
    data: data,
  })
}

export const saveCancelSubmitContract = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/cancel-submit',
    method: 'post',
    data: data,
  })
}

export const approveContractPackaget = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/approve-contractPackage',
    method: 'post',
    data: data,
  })
}

export const approveContractPackageNew = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/approve-contractPackage-new',
    method: 'post',
    data: data,
  })
}

export const approveQuotation = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/approve-quotation',
    method: 'post',
    data: data,
  })
}

export const deleteFileSelling = (data: any) => {
  return request({
    url: '/api/v1/FileManager/delete-file/' + data,
    method: 'delete',
  })
}

export const addSellingApprovalGroup = (data: any) => {
  return request({
    url: 'api/v1/SubmitForApproval/add-list-selling-approval',
    method: 'post',
    data: data,
  })
}

export const getListGroupSubmit = (user: string) => {
  let obj = {
    Page: '1',
    PageSize: '20',
    isPagingEnabled: false,
    Filters: [{FieldName: 'UserId', Comparision: '==', FieldValue: user}],
  }

  return request({
    url: 'api/v1/SubmitForApproval/get-list-group-submit-selling',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const getGroupSubmitUser = (nameGroup: string, groupDomainCode: string) => {
  return request({
    url:
      'api/v1/SubmitForApproval/get-group-submit-user-by-group-name?nameGroup=' +
      nameGroup +
      '&groupDomainCode=' +
      groupDomainCode,
    method: 'get',
  })
}